import { createFileRoute } from '@tanstack/react-router';
import NewZipBlastPage from '../../views/dashboard-zip-blasts/new';

export const Route = createFileRoute('/dashboard/zip-blasts_/new')({
  component: NewZipBlastPage,
});
